
import * as React from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import CurrencyInput from 'react-currency-input-field';

export const FormatMoney = props => {
    const handleChange = e => {
        if (props.onChange) {
          props.onChange({
            dataIndex: 0,
            dataItem: props.dataItem,
            field: props.field,
            syntheticEvent: e.syntheticEvent,
            value: e.target.value
          });
        }
      };

      

      const {
        dataItem
      } = props;
      const field = props.field || '';
      const dataValue = dataItem[field] === null || dataItem[field] === undefined  ? '' : dataItem[field];
      
      return <td>
        {dataItem.inEdit ?
        <CurrencyInput
            id='numberboxcell'
            name="input-name"
            defaultValue={0.000}
            decimalsLimit="2"
            //suffix="€"
            decimalSeparator="," 
            groupSeparator="."
            onValueChange={(value, name) => console.log(value, name)}
            onChange={handleChange} /> : dataValue.toString()
        }
      </td>
}